export enum CompanyRoles {
    GlobalAdmin = 0,
    MemberAdmin = 1,
    ReadPermission = 2,
}